module.exports = __webpack_public_path__ + "img/ui-checks.74eb85c6.svg";